module.exports = __webpack_public_path__ + "static/solar-apu-9892666e63fe038d06be9a21b3d4e10a.png";